import Button from '../../../atoms/buttons/filterButton';
import { selectMagicRemoteEnabled } from '../../../../../shared/store/slices/magicRemote.slice';
import { useAppSelector } from '../../../../../shared/store/hooks';
import { memo } from 'react';

interface Props {
  active: boolean;
  focused: boolean;
  text: string;
  onClick?: () => void;
}

function FilterButton({ active, focused, text, onClick }: Props) {
  const enabled = useAppSelector(selectMagicRemoteEnabled);
  return (
    <Button
      fill={active ? 1 : 0}
      focused={!enabled && focused}
      onClick={onClick}
    >
      {text}
    </Button>
  );
}

export default memo(FilterButton);
